// Mock data for URBANA+ Construtora portfolio website

export const companyInfo = {
  name: "URBANA+",
  subtitle: "CONSTRUTORA",
  tagline: "Construindo o presente. Transformando o futuro.",
  description: "Excelência em engenharia e construção para obras públicas e privadas com inovação, qualidade e responsabilidade.",
  email: "administrativo@urbamamais.com.br",
  phone: "(82) 98890-4487",
  cta: "Vamos construir algo grandioso juntos!"
};

export const mission = {
  title: "Missão",
  description: "Construir com segurança, qualidade e compromisso.",
  icon: "Target"
};

export const vision = {
  title: "Visão",
  description: "Ser referência em engenharia e construção.",
  icon: "Eye"
};

export const values = {
  title: "Valores",
  items: ["Ética", "Qualidade", "Sustentabilidade"],
  icon: "Heart"
};

export const services = [
  {
    id: 1,
    title: "Construção Civil",
    description: "Edificações residenciais, comerciais e industriais com qualidade e segurança.",
    image: "https://images.unsplash.com/photo-1621511075938-f03482369feb?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    title: "Infraestrutura Urbana",
    description: "Projetos de infraestrutura que transformam cidades e melhoram a mobilidade.",
    image: "https://images.unsplash.com/photo-1768962635991-0fa9543b7640?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    title: "Reformas e Manutenções",
    description: "Serviços de reforma e manutenção predial com agilidade e eficiência.",
    image: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?w=600&h=400&fit=crop"
  },
  {
    id: 4,
    title: "Construção de Praças Públicas",
    description: "Projetos de praças e espaços públicos de lazer para a comunidade.",
    image: "https://images.unsplash.com/photo-1656375459461-06e5292a58c1?w=600&h=400&fit=crop"
  },
  {
    id: 5,
    title: "Construção de Unidades de Saúde",
    description: "Edificação de hospitais, UBS e centros de saúde com infraestrutura moderna.",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=400&fit=crop"
  },
  {
    id: 6,
    title: "Construção de Creches",
    description: "Construção de creches e escolas infantis com ambientes seguros e acolhedores.",
    image: "https://images.unsplash.com/photo-1567746455504-cb3213f8f5b8?w=600&h=400&fit=crop"
  }
];

export const differentials = [
  {
    id: 1,
    title: "Planejamento Estratégico",
    description: "Projetos planejados com precisão para garantir resultados excepcionais.",
    icon: "ClipboardList"
  },
  {
    id: 2,
    title: "Equipe Qualificada",
    description: "Profissionais experientes e comprometidos com a excelência.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Segurança no Trabalho",
    description: "Protocolos rigorosos para garantir a segurança de todos.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Gestão Eficiente",
    description: "Processos otimizados para entregas no prazo e orçamento.",
    icon: "Settings"
  },
  {
    id: 5,
    title: "Inovação Tecnológica",
    description: "Tecnologias modernas para construções mais eficientes.",
    icon: "Lightbulb"
  }
];

export const heroImage = "https://images.unsplash.com/photo-1565862452829-e33c0b781ea3?w=1920&h=1080&fit=crop";

export const projects = [
  {
    id: 1,
    title: "Edifício Residencial Aurora",
    category: "Construção Civil",
    image: "https://images.unsplash.com/photo-1621511075938-f03482369feb?w=800&h=600&fit=crop",
    year: "2024"
  },
  {
    id: 2,
    title: "Viaduto Central",
    category: "Infraestrutura Urbana",
    image: "https://images.unsplash.com/photo-1768962635991-0fa9543b7640?w=800&h=600&fit=crop",
    year: "2023"
  },
  {
    id: 3,
    title: "Centro Esportivo Municipal",
    category: "Obras Públicas",
    image: "https://images.unsplash.com/photo-1599707254554-027aeb4deacd?w=800&h=600&fit=crop",
    year: "2024"
  },
  {
    id: 4,
    title: "Torre Comercial Platinum",
    category: "Construção Civil",
    image: "https://images.unsplash.com/photo-1551711974-faf378be34b2?w=800&h=600&fit=crop",
    year: "2023"
  }
];
